// extracted by mini-css-extract-plugin
export var about = "Byline-module--about--9e0c6";
export var connect = "Byline-module--connect--63ce7";
export var details = "Byline-module--details--cbaf7";
export var heading = "Byline-module--heading--1ffd2";
export var name = "Byline-module--name--79f17";
export var wrapper = "Byline-module--wrapper--5dd73";